<app-spinner [promise]="this.modelFetchPromise"></app-spinner>

<ng-container *ngIf="!this.modelFetchPromise && this.layoutHelper">
  <div class="vertical-sticky-container" #gestureContainer>

    <div class="vertical-flex-container" #horizontalScrollContainer>

      <div class="sticky-header">
        <div class="table-header">
          <div class="timeline-column cell"><span class="header-label">Timeline</span></div>
          <div class="standard-time-column cell border-left" style="width: 120px;min-width: 120px;"><span class="header-label">Tasks</span></div>
          <div class="standard-time-column cell border-left"><span class="header-label">Standard</span></div>
          <div class="on-task-time-column cell border-left"><span class="header-label">On Task</span></div>
        </div>
      </div>

      <div class="horizontal-flex-container">
        <div class="variable-size-content" #variableSizeContent>
          <app-gantt #gantt
                     [layoutHelper]="this.layoutHelper"
                     [timeDivisions]="this.timeDivisions"
                     [tasks]="this.model!.tasks"
                     [selectedTimeBlock]="this.selectedTimeBlock"
                     (selectedTimeBlockChanged)="this.onSelectionChanged($event)"></app-gantt>

          <div class="sticky-ruler">
            <svg class="ruler"
                 [style.width]="this.layoutHelper.svgWidth"
                 [style.height]="this.layoutHelper.svgHeight">
              <g>
                <!-- Iterate time-axis divisions -->
                <g *ngFor="let item of this.timeDivisions; let i = index">
                  <!-- Ruler lines -->
                  <line [attr.x1]="this.layoutHelper.getTimeDivisionLineXPosition(i)"
                        [attr.y1]="this.layoutHelper.bottom"
                        [attr.x2]="this.layoutHelper.getTimeDivisionLineXPosition(i)"
                        [attr.y2]="this.layoutHelper.rulerDivisionHeight + this.layoutHelper.bottom"
                        stroke-width="0.75"
                        stroke="#666666" />
                  <!-- Ruler line labels -->
                  <text [attr.x]="4 + this.layoutHelper.getTimeDivisionLineXPosition(i)"
                        [attr.y]="14 + this.layoutHelper.bottom">{{item.label}}</text>
                </g>
              </g>
            </svg>
          </div>
        </div>

        <div class="sticky-right-2 standard-time-column right-align" style="width: 120px;min-width: 120px;">
          <div *ngFor="let item of this.model!.tasks" class="task-header cell border-left numerical-value"
          [style.line-height]="this.layoutHelper.rowHeightCss"
          [style.height]="this.layoutHelper.rowHeightCss">
            <span class="header-label"
                  [style.line-height]="this.layoutHelper.rowHeightCss"
                  [attr.title]="item.name">
              {{item.name}}
            </span>
            <mat-icon *ngIf="this.needsNote(item)"
                      class="task-notification warning">chat_bubble_outline</mat-icon>
          </div>
          <!-- <div class="dummy" [style.height]="this.layoutHelper.rowHeightCss"></div> -->
        </div>

        <div class="sticky-right-2 standard-time-column">
          <div *ngFor="let item of this.model!.tasks" class="task-header cell border-left numeric-value"
               [style.line-height]="this.layoutHelper.rowHeightCss"
               [style.height]="this.layoutHelper.rowHeightCss">
            {{this.formatDuration(item.standardTimeInMinutes, 2)}}
          </div>
        </div>
        <div class="sticky-right-1 on-task-time-column">
          <div *ngFor="let item of this.model!.tasks" class="task-header cell border-left numeric-value"
               [class.overrun]="!item.isOngoing && item.timeBlocks.length > 0 && item.onTaskTimeInMinutes > item.standardTimeInMinutes"
               [class.underrun]="!item.isOngoing && item.timeBlocks.length > 0 && item.onTaskTimeInMinutes < item.standardTimeInMinutes"
               [style.line-height]="this.layoutHelper.rowHeightCss"
               [style.height]="this.layoutHelper.rowHeightCss">
            {{this.formatDuration(item.onTaskTimeInMinutes, 2)}}
          </div>
        </div>
      </div>
    </div>

    <div class="sticky-footer">
      <div class="table-footer">
        <div class="time-use-overview">
          <ng-container *ngIf="this.model!.endToEndDurationInMinutes">
            <div class="labels">
              <div class="segment" [style.flex]="this.remainder"></div>
              <div *ngIf="this.overrun" class="segment" [style.flex]="this.overrun">{{this.overrunLabel}}</div>
              <div *ngIf="this.underrun" class="segment" [style.flex]="this.underrun">{{this.underrunLabel}}</div>
            </div>
            <div class="bar">
              <div class="remainder segment" [style.flex]="this.remainder"></div>
              <div *ngIf="this.overrun; let value" class="overrun segment" [style.flex]="value"></div>
              <div *ngIf="this.underrun; let value" class="underrun segment" [style.flex]="value"></div>
            </div>
            <div class="markers">
              <div class="segment" [style.flex]="this.remainder">
                <div class="marker">{{this.midMarker}}</div>
              </div>
              <div *ngIf="this.overrun" class="segment" [style.flex]="this.overrun">
                <div class="marker">{{this.endMarker}}</div>
              </div>
              <div *ngIf="this.underrun" class="segment" [style.flex]="this.underrun">
                <div class="marker">{{this.endMarker}}</div>
              </div>
            </div>
          </ng-container>
        </div>
        <button type="button"
                aria-label="Finalise"
                color="primary"
                mat-raised-button
                [disabled]="!this.canFinalise"
                (click)="this.finalise()">
          <mat-icon aria-hidden="false">archive</mat-icon>
          {{ this.model?.isFinalised ? "FINALISED" : "FINALISE"}}
        </button>
      </div>
    </div>
  </div>

  <div class="block-navigation"
       [class.hidden]="!this.selectedTimeBlock">
    <button type="button"
            [class.mat-button-disabled]="!this.selectedTimeBlock?.previousInNavigation"
            [disableRipple]="!this.selectedTimeBlock?.previousInNavigation"
            aria-label="Previous"
            color="primary"
            (click)="this.onNavigatePrevious($event)"
            mat-fab>
      <mat-icon aria-hidden="false">navigate_before</mat-icon>
    </button>
    <span class="flex-spacer"></span>
    <button type="button"
            [class.mat-button-disabled]="!this.selectedTimeBlock?.nextInNavigation"
            [disableRipple]="!this.selectedTimeBlock?.nextInNavigation"
            aria-label="Next"
            color="primary"
            (click)="this.onNavigateNext($event)"
            mat-fab>
      <mat-icon aria-hidden="false">navigate_next</mat-icon>
    </button>
  </div>

  <div *ngIf="this.showGestureCenter"
       class="gesture-dot"
       [style.left]="this.gestureCenter.x + 'px'"
       [style.top]="this.gestureCenter.y + 'px'">
  </div>
</ng-container>